const EnumArticleReviewStatus = {
  ACCEPTED: "Accepted",
  COMPLETED: "Completed",
  DECLINED: "Declined",
  MAILED: "Mailed",
  NO_ANSWER: "No answer",
  SELECTED: "Selected",
};
export default EnumArticleReviewStatus;
